"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientProvider = void 0;
exports.useClient = useClient;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _cache = _interopRequireDefault(require("./cache"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// React Hooks: How to create and update Context.Provider
// https://dev.to/oieduardorabelo/react-hooks-how-to-create-and-update-contextprovider-1f68
// export const ClientContext = React.createContext({
//   cache: cacheStore.getState()
// })
// export class ClientProvider extends React.Component {
//   state = cacheStore.getState()
//   componentDidMount() {
//     this.unsubscribe = cacheStore.subscribe(() => {
//       const state = cacheStore.getState()
//       this.setState(state)
//     })
//   }
//   componentWillUnmount() {
//     this.unsubscribe()
//   }
//   render() {
//     const value = {
//       cache: this.state
//     }
//     return React.createElement(ClientContext.Provider,
//       { value: value },
//       this.props.children
//     )
//   }
// }
// export const ClientConsumer = ClientContext.Consumer
// export const useClient = () => React.useContext(ClientContext)
// export default ClientContext
var ClientProvider = exports.ClientProvider = /*#__PURE__*/function (_React$Component) {
  function ClientProvider() {
    (0, _classCallCheck2["default"])(this, ClientProvider);
    return _callSuper(this, ClientProvider, arguments);
  }
  (0, _inherits2["default"])(ClientProvider, _React$Component);
  return (0, _createClass2["default"])(ClientProvider, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_reactRedux.Provider, {
        store: _cache["default"]
      }, this.props.children);
    }
  }]);
}(_react["default"].Component);
function useClient() {
  var state = (0, _reactRedux.useSelector)(function (state) {
    return state;
  });
  return {
    cache: state
  };
}